import { styled, ListItemButton as MuiListItemButton, Paper as MuiPaper } from '@mui/material';

export const SidebarPaper = styled(MuiPaper)({
    width: '300px',
    minHeight: 'calc(100vh - 88px)',
    boxShadow: '4px 0 8px -2px rgba(0, 0, 0, 0.3)',
    borderRadius: 0, 
    borderTop: 20,
});

export const ListItemButton = styled(MuiListItemButton)(() => ({
    '&.Mui-selected': {
        backgroundColor: '#1e40af',
        color: '#fff',
        '& .MuiListItemIcon-root': {
            color: '#fff',
        },
        '&:hover': {
            backgroundColor: '#2563eb',
            color: '#fff',
        },
    },
    '&:hover': {
        backgroundColor: '#f3f4f6',
    },
}));
